import TemplateManagement from "@/routes/workspace/templateManagement.tsx";

export default function ManageTemplates() {
  return <TemplateManagement newDesign={true} />;
}
